import React, { PureComponent } from "react";
import Page from "../Page";

export default class ConferenceInfoPage extends PureComponent {
    componentDidMount = () => {

    }
    
    render() {

        return (
            <Page showHeader={false} title="">
                <div className="row mt-3 text-center">
                    <div className="col">
                        <h1>Coming Soon!</h1>
                    </div>
                </div>                                
            </Page>
        );
    }
}